import React from 'react'

import CloseIcon from '@mui/icons-material/Close'
import { DialogTitle, Stack } from '@mui/material'

import IconButton from '@podcastsoundboard/ps-lib/components/AccessibleIconButton'

const ClosableDialogTitle: React.FC<{
  children: React.ReactNode
  onClose: () => void
}> = ({ children, onClose }) => {
  return (
    <DialogTitle>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems={'flex-start'}
      >
        {children}

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </Stack>
    </DialogTitle>
  )
}

export default ClosableDialogTitle
